(function () {
  'use strict';

  /* ---- mobile nav ---- */
  var burger = document.querySelector('[data-burger]');
  var nav = document.querySelector('[data-nav]');
  if (burger && nav) {
    burger.addEventListener('click', function () {
      var open = nav.classList.toggle('is-open');
      burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  /* ---- quantity stepper ---- */
  document.querySelectorAll('.qty').forEach(function (box) {
    var input = box.querySelector('input');
    box.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var step = btn.dataset.step === 'up' ? 1 : -1;
        var next = Math.max(1, (parseInt(input.value, 10) || 1) + step);
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  /* ---- variant switching on product page ---- */
  var vSelect = document.querySelector('[data-variant-select]');
  if (vSelect) {
    vSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('variant', vSelect.value);
      window.history.replaceState({}, '', url.toString());

      var opt = vSelect.options[vSelect.selectedIndex];
      var priceEl = document.querySelector('[data-price]');
      var compareEl = document.querySelector('[data-compare]');
      var btn = document.querySelector('[data-add]');

      if (priceEl && opt.dataset.price) priceEl.textContent = opt.dataset.price;
      if (compareEl) {
        compareEl.textContent = opt.dataset.compare || '';
        compareEl.style.display = opt.dataset.compare ? '' : 'none';
      }
      if (btn) {
        var sold = opt.dataset.available === 'false';
        btn.disabled = sold;
        btn.textContent = sold ? btn.dataset.soldout : btn.dataset.label;
      }
    });
  }

  /* ---- cart line updates ---- */
  document.querySelectorAll('[data-cart-change]').forEach(function (el) {
    el.addEventListener('change', function () {
      submitCart(el.dataset.cartChange, el.value);
    });
  });
  document.querySelectorAll('[data-cart-remove]').forEach(function (el) {
    el.addEventListener('click', function () {
      submitCart(el.dataset.cartRemove, 0);
    });
  });

  function submitCart(line, quantity) {
    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: parseInt(line, 10), quantity: parseInt(quantity, 10) })
    })
      .then(function (r) { return r.json(); })
      .then(function () { window.location.reload(); })
      .catch(function () { window.location.reload(); });
  }

  /* ---- scroll reveal ---- */
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var targets = document.querySelectorAll('.reveal');
  if (reduce || !('IntersectionObserver' in window)) {
    targets.forEach(function (t) { t.classList.add('is-in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('is-in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    targets.forEach(function (t) { io.observe(t); });
  }
})();
